module.exports = __webpack_public_path__ + "static/media/info_marker.50869bde.svg";